import { useMutation } from '@tanstack/react-query';
import { postApiV1ScenariosByScenarioIdConvertToModel } from '../api/generated/sdk.gen';
import { useAccessToken } from '../auth/AccessTokenContext';
import { useErrorStore } from '../stores/ErrorStore';

interface ConvertParams {
  scenarioId: string;
  modelName?: string;
}

interface UseConvertScenarioToModelOptions {
  onSuccess?: () => void;
}

export const useConvertScenarioToModel = (
  options: UseConvertScenarioToModelOptions = {},
) => {
  const token = useAccessToken();
  const { addError } = useErrorStore();

  return useMutation({
    mutationFn: async ({ scenarioId, modelName }: ConvertParams) => {
      if (!token) throw new Error('Not authenticated');

      const response = await postApiV1ScenariosByScenarioIdConvertToModel({
        path: { scenarioId },
        body: {
          // eslint-disable-next-line camelcase
          scenario_id: scenarioId,
          // eslint-disable-next-line camelcase
          model_name: modelName,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    },
    onSuccess: options.onSuccess,
    onError: (error: unknown) => {
      const message = error instanceof Error ? error.message : 'Unknown error';
      addError(`Failed to convert scenario to analogue model: ${message}`);
    },
  });
};
